export default class ProductViewSwitcher {
    constructor({selector}) {
        if (!selector) return

        //this.wrapper = selector; // приходил селектор враппера переключателя
        //this.switcher = selector.querySelector('.js-switcher-input');
        //this.page = selector.closest('.js-product-row');
        this.page = selector;
        this.pageDataView = this.page.dataset ? this.page.dataset.view : '';
        this.eventListeners();
        //this.checkViewOnLoad();
        this.changeView();
    }

    eventListeners() {
        //this.switcher.addEventListener('change', this.switchView.bind(this));

        window.addEventListener('resize', ()=> {
            this.changeView();
        });
    }

    switchView() {
        if(this.switcher.checked) {
            this.page.classList.remove('b2c-view');
            // переинициализируем слайдер с крупными изображениями
            const bigSlider = this.page.querySelector('.slider-big-img');
            if (bigSlider) {
                $('.product-page .slider-big-img').slick('unslick');
                $('.product-page .slider-big-img').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    prevArrow: '<div class="arrow-slider a-prev"><svg width="12" height="12"><use xlink:href="/src/img/svg-sprite.svg#icon-arrow"></use></svg></div>',
                    nextArrow: '<div class="arrow-slider a-next"><svg width="12" height="12"><use xlink:href="/src/img/svg-sprite.svg#icon-arrow"></use></svg></div>',
                    fade: false,
                    infinite: true,
                    asNavFor: '.product-page .slider-nav',
                    responsive: [
                        {
                            breakpoint: 1900,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                        {
                            breakpoint: 1025,
                            settings: {
                                slidesToShow: 1,
                                arrows: false,
                                dots: true,
                            },
                        },
                    ]
                });
            }
        } else {
            this.page.classList.add('b2c-view');
        }
    }

    checkViewOnLoad() {
        const b2bState = window.localStorage.getItem('b2bState');

        if(b2bState === 'true') {
            this.page.classList.remove('b2c-view');
            this.switcher.checked = true;
            console.log('страница вида для бизнеса');
        }
        else if (b2bState === 'false') {
            this.page.classList.add('b2c-view');
            this.switcher.checked = false;
            console.log('страница вида для физ лиц')
        }
        else {
            this.page.classList.add('b2c-view');
            this.switcher.checked = false;
            console.log('страница вида для физ лиц - вид по умолчанию')
        }
    }

    /**
     * переключение с b2c на b2b для адаптива - для адаптива у страницы товара b2b и b2c общий дизайн
     */

    changeView() {
        const width = document.body.clientWidth;

        if(width < 1345) {
            this.removeB2CView();
        }

        if(width >= 1345 && this.pageDataView === 'b2c') {
            this.applyB2CView();
        }
    }

    removeB2CView() {
        if(this.page.classList.contains('b2c-view')) {
            this.page.classList.remove('b2c-view');
        }
    }

    applyB2CView() {
        //const b2bState = window.localStorage.getItem('b2bState');

        // if(b2bState === 'false') {
        //     this.page.classList.add('b2c-view');
        //     this.switcher.checked = false;
        // }

        // TODO прописать условие возвращения вида b2c для десктопа  (если пользователь авторизован как юрлицо, то не надо
        this.page.classList.add('b2c-view');
    }
}
